import React from "react";
import { useTheme } from "styled-components";

const BookmarkIcon = ({ size, state }) => {
  const {
    colors: { primarySeparator },
  } = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={state ? primarySeparator : "none"}
    >
      <path
        d="M5.5 4.39941C5.5 3.57099 6.17157 2.89941 7 2.89941H17C17.8284 2.89941 18.5 3.57099 18.5 4.39941V21.0994L12.3412 15.3512C12.1491 15.1719 11.8509 15.1719 11.6588 15.3512L5.5 21.0994V4.39941Z"
        stroke={primarySeparator}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BookmarkIcon;
